import { loadRemote } from './moduleFederation';

window.FS ||= {};
window.FS.tooltipsStatus = {
	manualToolTip: undefined,
	queue: [],
	loadingDynamicStatus: 'not loaded',
	loadDynamic: () => {
		if (window.FS.tooltipsStatus.loadingDynamicStatus == 'not loaded') {
			window.FS.tooltipsStatus.loadingDynamicStatus = 'loading';
			loadRemote('Tooltips').then(
				({ ToolTipsController, createToolTip }) => {
					// once loaded, swap out the global function and mark as loaded
					window.FS.tooltipsController = ToolTipsController();
					window.FS.createToolTip = createToolTip;

					window.FS.tooltipsStatus.loadingDynamicStatus = 'loaded';

					//add in any that are in the queue
					for (const queuedTooltip of window.FS.tooltipsStatus.queue) {
						window.FS.tooltipsController.add(queuedTooltip);
					}

					//if there was a manual invocation of createToolTip, pass that through
					if (window.FS.manualToolTip) {
						window.FS.createToolTip(window.FS.manualToolTip);
					}
				},
				e => {
					window.FS.tooltipsStatus.loadingDynamicStatus = 'error';
					console.error('Failed to load Tooltips/Tooltips', e);
				}
			);
		}
	},
};
window.FS.tooltipsController = {
	add: tooltip => {
		//add to the queue
		window.FS.tooltipsStatus.queue.push(tooltip);

		//kick off they dynamic load
		window.FS.tooltipsStatus.loadDynamic();
	},
};

window.FS.createToolTip = tooltip => {
	//save the manual tooltip
	window.FS.manualToolTip = tooltip;
	//kick off they dynamic load
	window.FS.tooltipsStatus.loadDynamic();
};
